(() => {
  const root = document.querySelector('[data-nh-configurator]');
  if (!root || root.dataset.initialized === 'true') return;

  const dataNode = root.querySelector('[data-nh-configurator-data]');
  if (!dataNode) return;

  let payload;
  try {
    payload = JSON.parse(dataNode.textContent);
  } catch (error) {
    console.error('9HEAT configurator data is invalid:', error);
    return;
  }

  root.dataset.initialized = 'true';

  const usagePresets = {
    daily: { zones: 4, cut: 'with', hood: 'nohood' },
    extended: { zones: 9, cut: 'with', hood: 'hood' },
    mobility: { zones: 9, cut: 'without', hood: 'hood' },
    maximum: { zones: 28, cut: 'with', hood: 'hood' }
  };
  const zoneCopy = {
    2: 'Une chaleur localisée sur deux points essentiels.',
    4: 'Une répartition simple entre l’avant et le dos.',
    9: 'Le bon équilibre pour les trajets et les longues attentes.',
    21: 'Une couverture étendue lorsque le froid dure vraiment.',
    28: 'La couverture la plus dense de la gamme personnalisable.'
  };
  const cutLabels = {
    with: 'Avec manches',
    without: 'Sans manches'
  };
  const hoodLabels = {
    hood: 'Capuche amovible',
    nohood: 'Sans capuche'
  };
  const variants = Array.isArray(payload.variants) ? payload.variants : [];
  const colors = Array.isArray(payload.colors) ? payload.colors : [];
  const sizes = Array.isArray(payload.sizes) ? payload.sizes : [];
  const preloaded = new Set();
  const questionCount = 5;
  const summaryStep = 6;
  const stepHeadings = {
    1: 'Commencez par votre quotidien.',
    2: 'Dosez la couverture chauffante.',
    3: 'Choisissez votre liberté de mouvement.',
    4: 'Terminez la coupe autour du cou.',
    5: 'Finalisez votre veste.',
    6: 'Vérifiez votre configuration.'
  };
  const state = {
    usage: 'extended',
    zones: 9,
    cut: 'with',
    hood: 'hood',
    color: colors.includes('Noir') ? 'Noir' : colors[0],
    size: sizes.includes('M') ? 'M' : sizes[0],
    previewMode: 'product',
    step: 1,
    variant: null,
    busy: false,
    imageTokens: {
      product: 0,
      zones: 0
    }
  };

  const nodes = {
    usage: [...root.querySelectorAll('[data-usage]')],
    zones: [...root.querySelectorAll('[data-zone]')],
    cuts: [...root.querySelectorAll('[data-cut]')],
    hoods: [...root.querySelectorAll('[data-hood]')],
    previewModes: [...root.querySelectorAll('[data-preview-mode]')],
    colors: root.querySelector('[data-color-options]'),
    sizes: root.querySelector('[data-size-options]'),
    images: [...root.querySelectorAll('[data-result-image]')],
    zoneOverlays: [...root.querySelectorAll('[data-zone-overlay]')],
    resultZones: [...root.querySelectorAll('[data-result-zone]')],
    resultStock: root.querySelector('[data-result-stock]'),
    resultName: root.querySelector('[data-result-name]'),
    resultCaptions: [...root.querySelectorAll('[data-result-caption]')],
    summaryName: root.querySelector('[data-summary-name]'),
    summaryReason: root.querySelector('[data-summary-reason]'),
    summaryZones: root.querySelector('[data-summary-zones]'),
    summaryCut: root.querySelector('[data-summary-cut]'),
    summaryHood: root.querySelector('[data-summary-hood]'),
    summaryColor: root.querySelector('[data-summary-color]'),
    summarySize: root.querySelector('[data-summary-size]'),
    summaryPrice: root.querySelector('[data-summary-price]'),
    summaryCompare: root.querySelector('[data-summary-compare]'),
    livePrices: [...root.querySelectorAll('[data-live-price]')],
    liveCompares: [...root.querySelectorAll('[data-live-compare]')],
    atc: root.querySelector('[data-configurator-atc]'),
    atcLabel: root.querySelector('[data-atc-label]'),
    message: root.querySelector('[data-configurator-message]'),
    steps: [...root.querySelectorAll('[data-config-step]')],
    stepBack: root.querySelector('[data-step-back]'),
    stepNext: root.querySelector('[data-step-next]'),
    stepNextLabel: root.querySelector('[data-step-next-label]'),
    stepEyebrow: root.querySelector('[data-step-eyebrow]'),
    stepHeading: root.querySelector('[data-step-heading]'),
    progress: root.querySelector('[data-progress-label]'),
    progressBar: root.querySelector('[data-progress-bar]'),
    mobilePreview: root.querySelector('.nh-builder__mobile-preview'),
    controls: root.querySelector('.nh-builder__controls')
  };

  const header = document.querySelector('[data-nh-header]');
  const syncHeaderOffset = () => {
    if (!header) return;
    const headerStyle = window.getComputedStyle(header);
    const stickyTop = Number.parseFloat(headerStyle.top) || 0;
    const visibleHeight = Math.max(0, Math.round(header.getBoundingClientRect().height + stickyTop));
    root.style.setProperty('--nh-builder-header-offset', `${visibleHeight}px`);
  };

  syncHeaderOffset();
  if ('ResizeObserver' in window && header) {
    const headerObserver = new ResizeObserver(syncHeaderOffset);
    headerObserver.observe(header);
  } else {
    window.addEventListener('resize', syncHeaderOffset, { passive: true });
  }

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: payload.currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount).replace(/\s/g, '\u00a0');
    } catch (_) {
      return `${amount.toFixed(2).replace('.', ',')}\u00a0€`;
    }
  };

  const syncButtonGroup = (buttons, value, attribute) => {
    buttons.forEach((button) => {
      const active = String(button.dataset[attribute]) === String(value);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const syncUsage = () => {
    const match = Object.entries(usagePresets).find(([, preset]) => (
      preset.zones === state.zones && preset.cut === state.cut && preset.hood === state.hood
    ));
    state.usage = match ? match[0] : '';
    syncButtonGroup(nodes.usage, state.usage, 'usage');
  };

  const findVariant = () => variants.find((variant) => (
    Number(variant.zones) === Number(state.zones)
  )) || null;

  const imageForState = (mode = state.previewMode) => {
    if (mode === 'zones') {
      return payload.images?.zones?.[state.cut]?.[state.hood]?.[String(state.zones)] || '';
    }
    return payload.images?.product?.[state.cut]?.[state.hood]?.[state.color] || '';
  };

  const normalizeUrl = (url) => {
    if (!url) return '';
    try {
      return new URL(url, document.baseURI).href;
    } catch (_) {
      return url;
    }
  };

  const preload = (url) => {
    const normalizedUrl = normalizeUrl(url);
    if (!normalizedUrl || preloaded.has(normalizedUrl)) return;
    preloaded.add(normalizedUrl);
    const image = new Image();
    image.decoding = 'async';
    image.src = normalizedUrl;
  };

  const preloadRelatedImages = () => {
    const run = () => {
      preload(imageForState('product'));
      preload(imageForState('zones'));
      colors.forEach((color) => preload(payload.images?.product?.[state.cut]?.[state.hood]?.[color]));
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 800 });
    else window.setTimeout(run, 80);
  };

  const swapImages = (images, url, alt, type) => {
    const normalizedUrl = normalizeUrl(url);
    if (!images.length || !normalizedUrl) return;
    const token = ++state.imageTokens[type];
    const loadingClass = `is-loading-${type}`;
    const targets = images.filter((image) => (
      normalizeUrl(image.currentSrc || image.src) !== normalizedUrl
    ));
    images.forEach((image) => { image.alt = alt; });
    if (!targets.length) return;

    targets.forEach((image) => image.parentElement?.classList.add(loadingClass));
    const next = new Image();
    next.decoding = 'async';
    next.onload = () => {
      if (token !== state.imageTokens[type]) return;
      targets.forEach((image) => {
        image.src = normalizedUrl;
        image.parentElement?.classList.remove(loadingClass);
      });
    };
    next.onerror = () => {
      if (token !== state.imageTokens[type]) return;
      targets.forEach((image) => image.parentElement?.classList.remove(loadingClass));
    };
    next.src = normalizedUrl;
  };

  const renderStep = () => {
    const isSummary = state.step === summaryStep;
    root.dataset.currentStep = String(state.step);
    nodes.steps.forEach((step) => {
      const active = Number(step.dataset.configStep) === state.step;
      step.hidden = !active;
      step.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    if (nodes.stepEyebrow) {
      nodes.stepEyebrow.textContent = isSummary
        ? 'Votre configuration'
        : `Question ${state.step} sur ${questionCount}`;
    }
    if (nodes.stepHeading) nodes.stepHeading.textContent = stepHeadings[state.step] || '';
    if (nodes.progress) nodes.progress.textContent = isSummary ? 'Prête' : `${state.step} / ${questionCount}`;
    if (nodes.progressBar) {
      const progress = isSummary ? 100 : (state.step / questionCount) * 100;
      nodes.progressBar.style.width = `${progress}%`;
    }
    if (nodes.stepBack) nodes.stepBack.hidden = state.step === 1;
    if (nodes.stepNext) nodes.stepNext.hidden = isSummary;
    if (nodes.stepNextLabel) {
      nodes.stepNextLabel.textContent = state.step === questionCount
        ? 'Voir mon récapitulatif'
        : 'Continuer';
    }
  };

  const setStep = (nextStep, shouldFocus = false) => {
    state.step = Math.max(1, Math.min(summaryStep, Number(nextStep) || 1));

    if (state.step === 2 || state.step === 3) state.previewMode = 'zones';
    if (state.step === 4 || state.step === 5 || state.step === summaryStep) state.previewMode = 'product';

    update();
    renderStep();

    if (shouldFocus) {
      const activeStep = nodes.steps.find((step) => Number(step.dataset.configStep) === state.step);
      window.requestAnimationFrame(() => {
        if (window.matchMedia('(max-width: 900px)').matches) {
          nodes.controls?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        activeStep?.focus({ preventScroll: true });
      });
    }
  };

  const renderColors = () => {
    if (!nodes.colors) return;
    nodes.colors.replaceChildren();
    const swatches = {
      Noir: '#111214',
      'Bleu marine': '#182942',
      Rouge: '#9f2927'
    };

    colors.forEach((color) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.color = color;
      button.classList.toggle('is-active', state.color === color);
      button.setAttribute('aria-pressed', state.color === color ? 'true' : 'false');
      button.setAttribute('aria-label', `Couleur ${color}`);

      const swatch = document.createElement('span');
      swatch.className = 'nh-builder__swatch';
      swatch.style.setProperty('--swatch', swatches[color] || '#111214');
      swatch.setAttribute('aria-hidden', 'true');
      button.append(swatch, document.createTextNode(color));
      button.addEventListener('click', () => {
        if (state.color === color) return;
        state.color = color;
        state.previewMode = 'product';
        update();
      });
      nodes.colors.append(button);
    });
  };

  const renderSizes = () => {
    if (!nodes.sizes) return;
    nodes.sizes.replaceChildren();
    sizes.forEach((size) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.size = size;
      button.textContent = size;
      button.classList.toggle('is-active', state.size === size);
      button.setAttribute('aria-pressed', state.size === size ? 'true' : 'false');
      button.setAttribute('aria-label', `Taille ${size}`);
      button.addEventListener('click', () => {
        if (state.size === size) return;
        state.size = size;
        update();
      });
      nodes.sizes.append(button);
    });
  };

  const clearMessage = () => {
    if (!nodes.message) return;
    nodes.message.textContent = '';
    nodes.message.classList.remove('is-error', 'is-success');
  };

  const update = () => {
    clearMessage();
    state.variant = findVariant();
    const available = Boolean(payload.product?.id && state.variant?.available);
    const zoneLabel = `${state.zones} zones`;
    const cutLabel = cutLabels[state.cut];
    const hoodLabel = hoodLabels[state.hood];

    syncButtonGroup(nodes.zones, state.zones, 'zone');
    syncButtonGroup(nodes.cuts, state.cut, 'cut');
    syncButtonGroup(nodes.hoods, state.hood, 'hood');
    syncButtonGroup(nodes.previewModes, state.previewMode, 'previewMode');
    syncUsage();
    renderColors();
    renderSizes();

    nodes.resultZones.forEach((node) => { node.textContent = zoneLabel; });
    if (nodes.resultName) nodes.resultName.textContent = '9HEAT personnalisée';
    nodes.resultCaptions.forEach((node) => {
      node.textContent = `${cutLabel} · ${hoodLabel} · ${state.color}`;
    });
    if (nodes.summaryName) nodes.summaryName.textContent = `Votre 9HEAT · ${zoneLabel}`;
    if (nodes.summaryReason) nodes.summaryReason.textContent = zoneCopy[state.zones] || '';
    if (nodes.summaryZones) nodes.summaryZones.textContent = zoneLabel;
    if (nodes.summaryCut) nodes.summaryCut.textContent = cutLabel;
    if (nodes.summaryHood) nodes.summaryHood.textContent = state.hood === 'hood' ? 'Amovible' : 'Aucune';
    if (nodes.summaryColor) nodes.summaryColor.textContent = state.color;
    if (nodes.summarySize) nodes.summarySize.textContent = state.size;

    if (nodes.resultStock) {
      nodes.resultStock.textContent = available ? 'Configuration disponible' : 'Configuration indisponible';
      nodes.resultStock.classList.toggle('is-unavailable', !available);
    }
    if (nodes.summaryPrice) nodes.summaryPrice.textContent = state.variant ? formatMoney(state.variant.price) : 'Indisponible';
    const livePrice = state.variant ? formatMoney(state.variant.price) : 'Indisponible';
    const liveCompare = Boolean(state.variant && state.variant.compareAtPrice > state.variant.price);
    nodes.livePrices.forEach((node) => { node.textContent = livePrice; });
    nodes.liveCompares.forEach((node) => {
      node.hidden = !liveCompare;
      node.textContent = liveCompare ? formatMoney(state.variant.compareAtPrice) : '';
    });
    if (nodes.summaryCompare) {
      const showCompare = Boolean(state.variant && state.variant.compareAtPrice > state.variant.price);
      nodes.summaryCompare.hidden = !showCompare;
      nodes.summaryCompare.textContent = showCompare ? formatMoney(state.variant.compareAtPrice) : '';
    }
    if (nodes.atc) nodes.atc.disabled = !available || state.busy;
    if (nodes.atcLabel) nodes.atcLabel.textContent = state.busy
      ? 'Ajout en cours...'
      : 'Ajouter ma veste personnalisée';
    const productPreviewUrl = imageForState('product');
    const zonePreviewUrl = imageForState('zones');
    const showingZones = state.previewMode === 'zones';
    const alt = showingZones
      ? `Répartition des ${zoneLabel} sur la veste 9HEAT ${cutLabel.toLowerCase()}, ${hoodLabel.toLowerCase()}`
      : `Veste chauffante 9HEAT personnalisée, ${cutLabel.toLowerCase()}, ${hoodLabel.toLowerCase()}, couleur ${state.color}`;
    nodes.images.forEach((image) => {
      image.parentElement?.classList.toggle('is-zone-mode', showingZones);
    });
    swapImages(nodes.images, productPreviewUrl, alt, 'product');
    swapImages(nodes.zoneOverlays, zonePreviewUrl, '', 'zones');
    preloadRelatedImages();
  };

  nodes.usage.forEach((button) => button.addEventListener('click', () => {
    const preset = usagePresets[button.dataset.usage];
    if (!preset) return;
    state.usage = button.dataset.usage;
    state.zones = preset.zones;
    state.cut = preset.cut;
    state.hood = preset.hood;
    state.previewMode = 'zones';
    update();
  }));

  nodes.zones.forEach((button) => button.addEventListener('click', () => {
    state.zones = Number(button.dataset.zone);
    state.previewMode = 'zones';
    update();
  }));

  nodes.cuts.forEach((button) => button.addEventListener('click', () => {
    state.cut = button.dataset.cut;
    state.previewMode = 'zones';
    update();
  }));

  nodes.hoods.forEach((button) => button.addEventListener('click', () => {
    state.hood = button.dataset.hood;
    state.previewMode = 'product';
    update();
  }));

  nodes.previewModes.forEach((button) => button.addEventListener('click', () => {
    state.previewMode = button.dataset.previewMode;
    update();
  }));

  nodes.stepBack?.addEventListener('click', () => setStep(state.step - 1, true));
  nodes.stepNext?.addEventListener('click', () => setStep(state.step + 1, true));

  nodes.atc?.addEventListener('click', async () => {
    if (state.busy || !payload.product?.id || !state.variant?.available) return;
    state.busy = true;
    update();

    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const endpoint = `${shopRoot.replace(/\/?$/, '/')}cart/add.js`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: state.variant.id,
            quantity: 1,
            properties: {
              Configuration: 'Veste personnalisée 9HEAT',
              'Zones chauffantes': `${state.zones} zones`,
              Manches: cutLabels[state.cut],
              Capuche: hoodLabels[state.hood],
              Couleur: state.color,
              Taille: state.size,
              _nh_configurateur: 'sur-mesure'
            }
          }]
        })
      });

      const resource = await response.json();
      if (!response.ok) throw new Error(resource?.description || resource?.message || 'Cart add failed');

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: resource || null,
          sourceId: '9heat-configurator',
          data: {
            source: '9heat-configurator',
            action: 'add',
            openDrawer: true,
            itemCount: 1
          }
        }
      }));

      if (nodes.message) {
        nodes.message.textContent = `Votre veste ${zoneLabelForMessage()}, ${state.color}, taille ${state.size} a été ajoutée au panier.`;
        nodes.message.classList.add('is-success');
      }
    } catch (error) {
      console.error('9HEAT configurator cart add failed:', error);
      if (nodes.message) {
        nodes.message.textContent = 'L’ajout n’a pas abouti. Réessayez dans un instant.';
        nodes.message.classList.add('is-error');
      }
    } finally {
      state.busy = false;
      if (nodes.atc) nodes.atc.disabled = !state.variant?.available;
      if (nodes.atcLabel) nodes.atcLabel.textContent = 'Ajouter ma veste personnalisée';
    }
  });

  const zoneLabelForMessage = () => `${state.zones} zones, ${cutLabels[state.cut].toLowerCase()}, ${hoodLabels[state.hood].toLowerCase()}`;

  nodes.zones.forEach((button) => {
    const zoneVariant = variants.find((variant) => Number(variant.zones) === Number(button.dataset.zone));
    if (!zoneVariant || button.querySelector('.nh-builder__zone-price')) return;
    const price = document.createElement('em');
    price.className = 'nh-builder__zone-price';
    price.textContent = formatMoney(zoneVariant.price);
    button.append(price);
  });

  update();
  renderStep();
})();
